"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.JsonUtil = void 0;
const class_transformer_1 = require("class-transformer");
const LangUtil_1 = require("./LangUtil");
const is_blank_1 = __importDefault(require("@sedan-utils/is-blank"));
class JsonUtil {
    static toArrayFromType(cls, json, options) {
        try {
            let source = json;
            if (typeof source === "string") {
                source = JsonUtil.parse(source);
                if (source === undefined)
                    return undefined;
            }
            return (0, class_transformer_1.plainToInstance)(cls, source, options);
        }
        catch (ex) {
            console.log(ex);
            return undefined;
        }
    }
    static toModelFromType(cls, json, options) {
        try {
            let source = json;
            if (typeof source === "string") {
                source = JsonUtil.parse(source);
                if (source === undefined)
                    return undefined;
            }
            return (0, class_transformer_1.plainToInstance)(cls, source, options);
        }
        catch (ex) {
            console.log(ex);
            return undefined;
        }
    }
    static toArrayFromInstance(clsObject, json) {
        try {
            return (0, class_transformer_1.plainToClassFromExist)(clsObject, json);
        }
        catch (ex) {
            console.log(ex);
            return undefined;
        }
    }
    static toModelFromInstance(clsObject, json) {
        try {
            let source = json;
            if (typeof source === "string") {
                source = JsonUtil.parse(source);
                if (source === undefined)
                    return undefined;
            }
            return (0, class_transformer_1.plainToClassFromExist)(clsObject, source);
        }
        catch (ex) {
            console.log(ex);
            return undefined;
        }
    }
    static stringify(object) {
        if (object === undefined)
            return undefined;
        try {
            return JSON.stringify((0, class_transformer_1.classToPlain)(object));
        }
        catch (ex) {
            console.log("toJson", ex);
            return undefined;
        }
    }
    static parseFromInstance(object) {
        if (!object) {
            return undefined;
        }
        return (0, class_transformer_1.instanceToPlain)(object);
    }
    static parse(text) {
        if (!text || (0, is_blank_1.default)(text))
            return undefined;
        let str = text.trimStart();
        if (!str.startsWith("{") && !str.startsWith("["))
            return undefined;
        return (0, LangUtil_1.tryBlock)(() => JSON.parse(str)).data;
    }
}
exports.JsonUtil = JsonUtil;
